import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';

export const useFetchSupplierInstallations = (supplierId, options = {}) => {
  return useQuery({
    queryKey: ['supplier-installations', supplierId],
    queryFn: async () => {
      if (!supplierId) return [];
      const response = await http.get(`/installations/supplier/${supplierId}`);
      return response.data;
    },
    enabled: !!supplierId,
    ...options,
  });
};
